export default {
  environment: process.env.NEXT_PUBLIC_ENV as "dev" | "prod" | "stage",
  version: process.env.NEXT_PUBLIC_VERSION as string,
  apiUrl: process.env.NEXT_PUBLIC_API as string,
};
